import { Media } from '../presentational/media';
import Skeleton from '../presentational/skeleton';
import SkeletonMythicPlusLeaderboard from './SkeletonMythicPlusLeaderboard';
import SkeletonMythicPlusRuns from './SkeletonMythicPlusRuns';

export default function SkeletonCharacterMythicPlusProgression() {
  return (
    <div>
      <Media greaterThanOrEqual="md">
        <div className="slds-grid slds-wrap slds-m-bottom--medium">
          <div className="slds-size--1-of-2 slds-small-size--1-of-2 slds-medium-size--1-of-2 slds-large-size--1-of-2">
            <Media lessThan="md">
              <Skeleton width="80%" height={32} style={{ borderRadius: '0.25rem' }} />
            </Media>
            <Media greaterThanOrEqual="md">
              <Skeleton width="40%" height={32} style={{ borderRadius: '0.25rem' }} />
            </Media>
          </div>
          <div className="slds-size--1-of-2 slds-small-size--1-of-2 slds-medium-size--1-of-2 slds-large-size--1-of-2">
            <Skeleton width="100%" height={32} style={{ borderRadius: '0.25rem' }} />
          </div>
        </div>
      </Media>
      <Media lessThan="md">
        <div className="slds-grid slds-wrap slds-m-bottom--medium">
          <div className="slds-size--1-of-2 slds-small-size--1-of-2">
            <Skeleton width="80%" height={32} style={{ borderRadius: '0.25rem' }} />
          </div>
          <div className="slds-grid slds-size--1-of-2 slds-grid--align-end slds-small-size--1-of-2">
            <Skeleton width={52} height={32} style={{ borderRadius: '0.25rem' }} />
          </div>
        </div>
      </Media>

      <Skeleton height={119} style={{ marginBottom: 24 }} />

      <SkeletonMythicPlusLeaderboard />

      <SkeletonMythicPlusRuns />
    </div>
  );
}
